'use client';
import { createContext, useContext } from 'react';
const AskComposerTranscriptionImplementationContext = createContext(undefined);
export const AskComposerTranscriptionImplementationProvider = AskComposerTranscriptionImplementationContext.Provider;
export function useAskComposerTranscriptionImplementation() {
    return useContext(AskComposerTranscriptionImplementationContext);
}
//# sourceMappingURL=askComposerTranscriptionImplementationShared.js.map